export default "__VITE_ASSET__B5HrU622__"